import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { UserLogout } from '../actions/authActions';

import {
  Avatar,
  Box,
  Button,
  Collapse,
  Divider,
  Group,
  Popover,
  Select,
  Text,
  UnstyledButton,
} from '@mantine/core';
import {
  IconChevronDown,
  IconChevronUp,
  IconLogout,
  IconSwitchHorizontal,
  IconUser,
} from '@tabler/icons-react';
import { useUserAvatar } from '../hooks/useUserAvatar';

const UserAccountButton = ({
  collapsed,
  user,
  activePermission,
  onPermissionChange,
  currentPermission,
  permissionOptions,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);

  const avatarText = useUserAvatar(user);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(UserLogout());
    navigate('/');
  };

  const handlePermissionChange = (perm) => {
    onPermissionChange(perm);
    setOpened(false);
  }

  const menuOptions = (
    <>
      <Text size="sm" truncate="end" title={user?.usermail} mb="xs">
        {user?.usermail}
      </Text>

      <Select
        variant="unstyled"
        data={permissionOptions}
        value={currentPermission}
        onChange={(value) => handlePermissionChange(value)}
        placeholder="Cambiar rol"
        allowDeselect={false}
        checkIconPosition="right"
        leftSection={<IconUser size={16} stroke={2} />}
        classNames={{
          wrapper: 'select-role-wrapper',
        }}
        maxDropdownHeight={280}
        comboboxProps={{
          zIndex: 4000,
          position: 'bottom-start',
          withinPortal: true,
        }}
        styles={{
          input: {
            color: 'rgba(221, 221, 221, 1)',
            fontWeight: 600,
          },
        }}
      />

      <Button
        variant="subtle"
        color="rgba(221, 221, 221, 1)"
        fullWidth
        leftSection={<IconSwitchHorizontal size={16} />}
        justify="start"
        onClick={() => navigate('/procesos-evaluacion')}
      >
        Cambiar de Proceso
      </Button>
      <Divider my={3} />
      <Button
        variant="subtle"
        color="red"
        justify="start"
        fullWidth
        leftSection={<IconLogout size={16} />}
        onClick={handleLogout}
      >
        Cerrar Sesión
      </Button>
    </>
  );

  return (
    <Box>
      {collapsed ? (
        <Popover
          position="right-end"
          withArrow
          arrowPosition='center'
          shadow="md"
          offset={18}
          withinPortal
          zIndex={4000}
        >
          <Popover.Target>
            <UnstyledButton className="user-section">
              <Group justify="center">
                <Avatar radius="xl" name={avatarText} color="initials" />
              </Group>
            </UnstyledButton>
          </Popover.Target>

          <Popover.Dropdown className="user-options" p="sm">
            {menuOptions}
          </Popover.Dropdown>
        </Popover>
      ) : (
        <>
          <UnstyledButton
            onClick={() => setOpened(!opened)}
            className="user-section"
          >
            <Group wrap="nowrap" justify="flex-start">
              <Avatar radius="xl" name={avatarText} color="initials" />
              <div style={{ flex: 1 }}>
                <Text size="sm" fw={500}>
                  {user?.username || 'No autenticado'}
                </Text>
                <Text c="dimmed" size="xs">
                  {activePermission?.displayName || 'default'}
                </Text>
              </div>
              {opened ? <IconChevronUp size={15} /> : <IconChevronDown size={15} />}
            </Group>
          </UnstyledButton>

          <Collapse in={opened}>
            <Box className="user-options" mt="xs" p="xs" miw={220}>
              {menuOptions}
            </Box>
          </Collapse>
        </>
      )}
    </Box>
  );
};

export default UserAccountButton;
